import { apiFetch } from './api';

const GENERIC_UPLOAD_ERROR = 'Failed to upload files.';

interface UploadResponse {
  status_message?: string;
  data?: {
    upload_status?: unknown;
  };
}

/**
 * Upload the files in formData to the Hype knowledge base.
 */
export async function uploadHypeFiles(formData: FormData): Promise<void> {
  const response = await apiFetch('/api/hype/upload', {
    method: 'POST',
    body: formData,
  });

  let payload: UploadResponse;
  try {
    payload = (await response.json()) as UploadResponse;
  } catch {
    throw new Error(response.ok ? GENERIC_UPLOAD_ERROR : `Upload failed (${response.status}).`);
  }

  if (!response.ok) {
    throw new Error(payload.status_message || `Upload failed (${response.status}).`);
  }

  const uploadStatus = payload.data?.upload_status;
  if (!Array.isArray(uploadStatus) || uploadStatus.length === 0) {
    throw new Error(GENERIC_UPLOAD_ERROR);
  }

  if (!uploadStatus.every((status) => status === 'completed')) {
    throw new Error('One or more files failed to upload.');
  }
}

export function getUploadErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  if (typeof error === 'string' && error.trim()) {
    return error;
  }
  return GENERIC_UPLOAD_ERROR;
}
